export default {"src":"/_next/static/media/half-star.211730d1.svg","height":14,"width":17,"blurWidth":0,"blurHeight":0};